import React, { Dispatch, SetStateAction } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Endpoint } from '../../../../../router/routes.config';

interface IProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AlertDialog(props: IProps) {
  const { open, setOpen } = props;
  const history = useHistory();

  function handleClose() {
    setOpen(false);
  }

  function handleClick() {
    handleClose();
    history.push(Endpoint.DEPLOYMENTS);
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Attention</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Vous vous apprêtez à quitter le traitement du déploiement. Toutes les
          étapes effectuées ne seront pas sauvegardées.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClick} color="primary">
          Abandonner le déploiement
        </Button>
        <Button onClick={handleClose} color="primary" autoFocus>
          Annuler
        </Button>
      </DialogActions>
    </Dialog>
  );
}
